import type { HTMLAttributes } from "react";
import { classNames } from "../components/internal/classNames";
import "./BrandWordmark.css";

export type BrandWordmarkProps = Omit<HTMLAttributes<HTMLSpanElement>, "children">;

export function BrandWordmark({ className, ...props }: BrandWordmarkProps) {
  return (
    <span {...props} className={classNames("cp-brand-wordmark", className)}>
      CarePass
    </span>
  );
}
